import React from 'react';
import { Box } from '@amzn/awsui-components-react';
import reInventBackground from './reinvent.png';
import messages from './CustomEventContainer.messages';
import CustomContainer from '../CustomContainer';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const reInventName = 'reInvent23';

const CustomEventContainer = ({ eventName, components }) => {
  const { formatMessage } = useIntl();
  return (
    <div
      data-testid="customEventContainer"
      style={{
        height: '100%',
        backgroundImage:
          eventName === reInventName
            ? `url(${reInventBackground})`
            : 'linear-gradient(180deg, #23379b 0%, #314fbf 50%, #7749bf 100%)',
        backgroundSize: 'cover',
      }}
    >
      {eventName === reInventName ? (
        <>
          <Box padding="xxxl">
            <div style={{ color: 'white' }}>
              <Box variant="h1" color="inherit" fontSize="display-l">
                {formatMessage(messages.reInventTitle, {
                  b: chunk => <b>{chunk}</b>,
                })}
              </Box>
              <Box variant="p" color="inherit">
                {formatMessage(messages.reInventMessage)}
              </Box>
            </div>
          </Box>
          {components.markdown ? (
            <CustomContainer components={components.customContent} />
          ) : null}
        </>
      ) : (
        <CustomContainer components={components.customContent} />
      )}
    </div>
  );
};

CustomEventContainer.propTypes = {
  eventName: PropTypes.string.isRequired,
  components: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          type: PropTypes.oneOf(['markdown']).isRequired,
          componentId: PropTypes.string.isRequired,
          value: PropTypes.shape({
            locales: PropTypes.arrayOf(
              PropTypes.shape({
                locale: PropTypes.string.isRequired,
                markdown: PropTypes.string.isRequired,
              }).isRequired
            ).isRequired,
            theme: PropTypes.string,
            padding: PropTypes.bool,
          }),
        }),
        PropTypes.shape({
          type: PropTypes.oneOf(['signInButton']).isRequired,
          componentId: PropTypes.string.isRequired,
          value: PropTypes.shape({
            idp: PropTypes.string.isRequired,
            primary: PropTypes.bool,
            locales: PropTypes.arrayOf(
              PropTypes.shape({
                locale: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
              })
            ).isRequired,
          }),
        }),
      ])
    )
  ).isRequired,
};

export default CustomEventContainer;
